import { SectionProps } from "@/types";
import { cn } from "@/lib/utils";

export default function Section({
  id,
  as: Component = "section",
  className,
  children,
}: SectionProps) {
  return (
    <Component id={id} className={cn("relative w-full", className)}>
      {children}
    </Component>
  );
}
